module.exports = __webpack_public_path__ + "34778e7d.svg";